export const SuspenseFallback = () => {
  return <div className="bg-dope-black h-full" />
}
